import React from "react";
import { useRecoilState } from "recoil";
import {
  ContentStoreType,
  STORE_CLOSE,
  STORE_OPEN,
  STORE_PAUSE,
} from "../../../controller/MasterController";
import { langState, langText } from "../../../recoil/lang";
import {
  contentName,
  getBadgeComment,
  getDifferDate,
  getStoreName,
} from "../../../utils/util";
import { checkOpenClosingTime } from "./contentUtil";

interface CategoryProps {
  item: ContentStoreType;
  currentDate: Date;
  navigateSector: any;
  type: string;
}

const StoreContent = ({
  item,
  currentDate,
  navigateSector,
  type,
}: CategoryProps) => {
  const [lang, setLang] = useRecoilState<number>(langState);

  const deliveryTime =
    item.data.store_availability === STORE_OPEN
      ? item.data.delivery_estimated_time
      : -1;

  const checkGroupedTime = () => {
    return checkOpenClosingTime(item.data, currentDate);
  };
  const couponName = item.data.coupon_yn && item.data.coupon_badge_name;

  return (
    <div className="storeItem" onClick={() => navigateSector(item)}>
      <div className="badgeWrap">
        {type !== "owner" && item.data.base_delivery_price === 0 && (
          <div className="commentBox free">
            <h5>
              {langText.free_delivery[lang]}
              <img
                loading="lazy"
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_delivery.svg`}
                alt="배달"
              />
            </h5>
          </div>
        )}
        {getBadgeComment(item.data, lang) && (
          <div className="commentBox subtitle">
            <h5>{getBadgeComment(item.data, lang)}</h5>
          </div>
        )}
        {couponName && (
          <div className="commentBox coupon">
            <h5>{contentName(couponName, lang)}</h5>
          </div>
        )}
      </div>
      {checkGroupedTime().status === "close" ? (
        <div className="arrivalWrap left">
          <div className="commentBox">
            <h5>
              {langText.closed[lang]} {checkGroupedTime().time}
              {langText.minute[lang]}
              {langText.deadline[lang]}
            </h5>
          </div>
        </div>
      ) : (
        checkGroupedTime().status === STORE_OPEN && (
          <div className="arrivalWrap left">
            <div className="commentBox">
              <h5>
                {langText.open[lang]} {checkGroupedTime().time}
                {langText.minute[lang]}
                {langText.deadline[lang]}
              </h5>
            </div>
          </div>
        )
      )}
      {deliveryTime !== -1 && (
        <div className="arrivalWrap">
          <div className="commentBox">
            <h5 className="time">
              {deliveryTime}
              {langText.minute[lang]}
            </h5>
          </div>
        </div>
      )}
      <>
        {item.data.store_availability === STORE_CLOSE && (
          <div className="closedImg">
            {`${getDifferDate(
              new Date(),
              new Date(item.data.next_open_time),
              lang
            )}`}
          </div>
        )}
        {item.data.store_availability === STORE_PAUSE && (
          <div className="closedImg">{langText.pause[lang]}</div>
        )}
        {item.data.store_img_url ? (
          <img
            loading="lazy"
            className="titleImg"
            src={item.data.store_img_url}
            alt="storeImg"
          />
        ) : (
          <div className="titleImg" />
        )}
      </>
      <div className="itemContent">
        <p>{getStoreName(item.data, lang)}</p>
      </div>
    </div>
  );
};
export default StoreContent;
